import {useState, useRef} from "react";

export const useSetIframeHeight = () => {
  //Importante definir un valor alto para usar hashtag para hacer scroll dentro de iframes
  const [height, setHeight] = useState(10000);
  const innerRef = useRef(null);
  
  const handleResizeHeight = () => {
    const {body} = innerRef.current.contentWindow.document;
    const contentHeight = Math.max(
      body.clientHeight,
      body.offsetHeight,
      body.scrollHeight
    );
    
    if (contentHeight !== height) {
      setHeight(contentHeight);
    }
  };
  
  return [height, innerRef, handleResizeHeight]
}